import { ElementTypeNS, IConfig } from "./pview.model";

const config: IConfig  = {
    debug: false,
    debugRenderTime: false,
    svgNS: ElementTypeNS.svgNS,
    htmlNS: ElementTypeNS.htmlNS
};

export { config };